module.exports = __webpack_public_path__ + "img/checkerboard.e8ed804e.png";